module.exports = __webpack_public_path__ + "img/offer-detail-logo.ae1e738e.png";